import { ContainerWrapper } from '../Container'
import SectionHeading from './SectionHeading'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'
import { isMobile } from 'react-device-detect'

const BETTER_DIRECT_MAIL_MODAL_PROPS = {
    formName: 'Better Direct Mail Strategy Call',
}

const ConnectIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            fill="#FFF8E9"
            className="w-[50px] h-auto">
            <path d="M582.8 305L532.7 218.2C533.8 216.1 534.6 213.6 534.6 211C534.6 203 527.9 196.3 519.9 196L464.4 100.1C464.9 98.5 465.5 96.9 465.5 95.3C465.5 86.7 458.5 80 450.2 80C445.4 80 441.4 82.1 438.4 85.6L331.8 85.6C329.1 82.1 325.1 80 320.3 80C315.5 80 311.5 82.1 308.8 85.6L202.7 85.6C199.8 82.1 195.7 80 190.9 80C182.6 80 175.6 86.7 175.6 95.3C175.6 96.9 176.1 98.8 176.7 100.1L120.7 197.3C115.3 199.7 111.6 204.8 111.6 211C111.6 211.5 111.9 212.1 111.9 212.6L58.6 304.7C51.4 306 46 312.2 46 319.7C46 326.9 51.1 333.1 58.1 334.7L113.3 430.1C112.8 431.7 112.5 433 112.5 434.9C112.5 442.1 117.6 448.3 124.6 449.6L176.3 539.3C175.8 540.9 175.2 542.8 175.2 544.7C175.2 553.3 182.2 560 190.5 560C195.3 560 199.3 557.9 202 554.6L308.9 554.6C311.6 557.8 315.9 560 320.4 560C324.9 560 329.2 557.9 331.9 554.6L439 554.6C441.7 557.5 445.7 559.4 450 559.4C458.6 559.4 465.3 552.4 465.3 544.1C465.3 542.5 465 541.2 464.5 539.8L516.2 449.5C523.2 448.2 528.3 442 528.3 434.8C528.3 433.2 528 431.6 527.5 430L582.4 334.6C589.4 333.3 594.7 327.1 594.7 319.6C594.7 312.4 589.6 306.2 582.9 304.9zM185.8 514.7L142.1 438.9L185.8 438.9L185.8 514.7zM185.8 430.9L142.1 430.9C141.8 429.8 141.3 428.8 140.8 427.7L185.8 380.3L185.8 430.9zM185.8 368.5L135.4 421.8C134.1 421.3 132.7 420.5 131.4 420.2L75.7 323.8C76.2 322.5 76.2 321.1 76.2 319.8C76.2 318.5 76.2 317.4 75.9 316.3L127.9 226.3C130.6 226 133.3 225.2 135.7 223.6L185.8 275.6L185.8 368.5zM185.8 266.2L140 218.8C141.3 216.7 142.1 214 142.1 211C142.1 210.7 141.8 210.2 141.8 209.9L185.7 194.1L185.7 266.2zM185.8 185.6L142.1 201.4L185.8 125.9L185.8 185.6zM512.3 224.7L513.1 226L477.7 393.1L413.9 325.9L511.9 224.4L512.2 224.7zM324.1 419.1L335.6 430.9L312.8 430.9L324.1 419.1zM323.8 407.8L240.5 322.4L320.1 238L403.1 325.6L323.8 407.8zM329.2 413.7L408.5 331.5L476 402.8L470.1 430.9L346.1 430.9L329.2 413.8zM442.7 108.4C443.8 108.9 444.8 109.5 446.2 109.7L504.1 210.4L504.1 210.9C504.1 213.8 504.9 216.5 506.2 218.7L408.7 319.9L325.7 232.3L442.8 108.3zM433.6 106.3L320 226.6L262.9 166.3L429.2 106.3L433.5 106.3zM310.1 106.3C312.8 109 316.3 110.6 320.3 110.6C324.3 110.6 327.8 109 330.5 106.3L405.5 106.3L257.1 159.9L206.2 106.3L310.1 106.3zM193.9 111.9L195 109.8C195.9 109.6 196.8 109.3 197.7 109L248.9 162.8L194 182.6L194 111.9zM193.9 191.2L254.7 169.2L314.4 232.4L234.8 316.5L193.8 274.4L193.8 191.1zM193.9 283.9L230.3 321.7L193.9 360L193.9 283.9zM193.9 371.8L236 327.3L318.8 413.3L301.7 431L194 431L194 371.8zM200.9 533.9C199.3 532.3 197.4 531.2 195 530.4L193.9 528.8L193.9 439.1L293.8 439.1L202.2 533.9L200.9 533.9zM330.8 533.9C328.1 531.5 324.4 529.6 320.4 529.6C316.4 529.6 312.6 531.5 310 533.9L213.6 533.9L305.2 439.1L343.5 439.1L435.1 533.9L330.9 533.9zM450.8 522.1L446.5 529.6C445.2 529.9 444.1 530.4 443 530.9L353.8 439L468.2 439L450.8 522zM463.7 499.9L476.6 439.1L498.6 439.1L463.8 499.9zM498.5 431.1L478.1 431.1L482.7 409.9L499.8 428.1C499.3 428.9 498.7 430 498.5 431zM564.7 323.7L509.3 420.4C508 420.9 506.6 421.5 505.3 422.3L484.7 400.3L519.3 236.4L565.1 315.7C564.8 317 564.3 318.4 564.3 320C564.3 321.3 564.6 322.4 564.8 323.7z" />
        </svg>
    )
}

const RibbonIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            fill="#FFF8E9"
            className="w-[50px] h-auto">
            <path d="M363.1 64C396.5 64 427.6 81.4 445 109.9C446.2 111.9 458 131.2 480.3 167.7C501.4 202.2 498.6 246.2 473.3 277.7L406.3 361.7L492.5 470C498 476.9 496.9 486.9 490 492.5L410 556.5C403.1 562 393 560.9 387.5 554L166.6 277.8C141.3 246.3 138.5 202.3 159.6 167.8C182 131.2 193.7 111.9 195 109.9C212.4 81.4 243.4 64 276.9 64L363.2 64zM320 253.2L368.6 192L271.3 192L319.9 253.2zM203 400.2L289.2 508L252.4 554C246.9 560.9 236.8 562 229.9 556.5L149.9 492.5C143 487 141.9 476.9 147.4 470L203 400.2z" />
        </svg>
    )
}

const SyncIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            fill="#FFF8E9"
            className="w-[50px] h-auto">
            <path d="M129.9 292.5C143.2 199.5 223.3 128 320 128C373 128 421 149.5 455.8 184.2C456 184.4 456.2 184.6 456.4 184.8L464 192L416.1 192C398.4 192 384.1 206.3 384.1 224C384.1 241.7 398.4 256 416.1 256L544.1 256C561.8 256 576.1 241.7 576.1 224L576.1 96C576.1 78.3 561.8 64 544.1 64C526.4 64 512.1 78.3 512.1 96L512.1 149.4L500.8 138.7C454.5 92.6 390.5 64 320 64C191 64 84.3 159.4 66.6 283.5C64.1 301 76.2 317.2 93.7 319.7C111.2 322.2 127.4 310 129.9 292.6zM573.4 356.5C575.9 339 563.7 322.8 546.3 320.3C528.9 317.8 512.6 330 510.1 347.4C496.8 440.4 416.7 511.9 320 511.9C267 511.9 219 490.4 184.2 455.7C184 455.5 183.8 455.3 183.6 455.1L176 447.9L223.9 447.9C241.6 447.9 255.9 433.6 255.9 415.9C255.9 398.2 241.6 383.9 223.9 383.9L96 384C87.5 384 79.3 387.4 73.3 393.5C67.3 399.6 63.9 407.7 64 416.3L65 543.3C65.1 561 79.6 575.2 97.3 575C115 574.8 129.2 560.4 129 542.7L128.6 491.2L139.3 501.3C185.6 547.4 249.5 576 320 576C449 576 555.7 480.6 573.4 356.5z" />
        </svg>
    )
}

const steps = [
    {
        number: 1,
        title: 'Connect with your Dedicated Account Rep',
        description:
            'We’ll review your current workflow, data format, and timelines, then map a fast migration plan.',
        Icon: ConnectIcon,
    },
    {
        number: 2,
        title: 'Send your existing templates',
        description:
            'Our graphic design team will add them to your account for immediate use—kept on brand and print-ready.',
        Icon: RibbonIcon,
    },
    {
        number: 3,
        title: 'Place your order',
        description:
            'Schedule your Multi-touch Proven Mix Campaign and track each drop with AccuTrace.',
        Icon: SyncIcon,
    },
]
function StepContent({ title, description }) {
    return (
        <>
            <h3 className="md:mt-6 text-xl font-semibold text-olm-black max-w-sm md:max-w-full">
                {title}
            </h3>
            <p className="mt-2 text-olm-new-black max-w-sm leading-relaxed md:max-w-full">
                {description}
            </p>
        </>
    )
}
function Step({ title, description, Icon }) {
    return (
        <div className="flex flex-row md:flex-col md:items-center text-center w-full flex-wrap gap-4 md:gap-0">
            <div className="relative z-10">
                <div className="w-[60px] h-[60px] md:w-[60px] md:h-[60px] rounded-full bg-[#f05a2b] flex items-center justify-center shadow-[0_10px_24px_rgba(255,101,47,0.18)]">
                    <Icon />
                </div>
            </div>
            {isMobile ? (
                <div className="w-3/4">
                    <StepContent title={title} description={description} />
                </div>
            ) : (
                <StepContent title={title} description={description} />
            )}
        </div>
    )
}

export default function SwitchProcess({ heading = '3-Step Switch Process' }) {
    return (
        <section
            aria-labelledby="how-it-works-heading"
            className="py-5"
            style={{ marginTop: '0px' }}>
            <ContainerWrapper>
                <SectionHeading>{heading}</SectionHeading>
                {/* Steps with connectors on md+ */}
                <div className="w-full max-w-6xl px-2 py-5 mt-8 mx-auto">
                    <div className="flex flex-col md:flex-row items-start md:justify-center gap-6 md:gap-6">
                        {steps.map((s, idx) => (
                            <div
                                key={s.number}
                                className={`flex items-center w-full md:w-1/${steps.length} relative`}>
                                <Step {...s} />
                                {/* connector line except after the last item (md+) */}
                                {idx < steps.length - 1 && (
                                    // <div className="h-[2px] bg-[#ED5C2F] w-16 md:w-full mx-4 shrink-0 absolute left-1/2 top-[30px]" />
                                    <div className="h-full w-[2px] top-[calc(50%-20px)] left-[15px] md:h-[2px] bg-[#ED5C2F] md:w-full mx-4 shrink-0 absolute md:left-1/2 md:top-[30px] z-1" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTAs */}
                <div className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 max-w-3xl mx-auto">
                    <div className="max-w-[220px] w-full">
                        <BookACallButton
                            Modal={HomepageBookCallLeadModal}
                            modalProps={BETTER_DIRECT_MAIL_MODAL_PROPS}>
                            Book A Call Now
                        </BookACallButton>
                    </div>
                </div>
            </ContainerWrapper>
        </section>
    )
}
